// Tiny constant module so consumers can read the localStorage key without
// pulling the full AppOverviewPage component (and its lucide-react icons) into
// the initial bundle.
export const APP_OVERVIEW_KEY = 'kairos_overview_v1';
